import { render } from "./HighMember.vue?vue&type=template&id=e53a66e0"
import script from "./HighMember.vue?vue&type=script&lang=js"
export * from "./HighMember.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__